
<!-- Mobile overlay - only when sidebar is open on small screens -->
@if (expanded) {
  <div 
    class="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-9998"
    (click)="closeSidebar()"
  ></div>
}

<aside
  [ngClass]="expanded ? 'translate-x-0' : '-translate-x-full lg:translate-x-0 lg:w-[90px]'"
  class="sidebar fixed left-0 top-0 z-9999 flex h-screen w-[290px] flex-col overflow-y-hidden border-r border-gray-200 bg-white px-5 duration-300 ease-linear dark:border-gray-800 dark:bg-black lg:relative lg:z-auto"
>
  <div
    [ngClass]="expanded ? 'justify-between' : 'justify-center'"
    class="sidebar-header flex items-center gap-2 pb-7 pt-8"
  >
    <a routerLink="/dashboard">
      <span class="logo" [ngClass]="expanded ? '' : 'hidden'">
        <img class="dark:hidden" priority [ngSrc]="logoUrl" alt="Logo" height="40" width="160" />
        <img class="hidden dark:block" priority [ngSrc]="logoUrl" alt="Logo" height="40" width="160" />
      </span>
      <img
        class="logo-icon"
        priority
        [ngClass]="expanded?'hidden':'lg:block'"
        [ngSrc]="logoUrl"
        alt="Logo"
        height="10" width="40" />
    </a>
  </div>

  <div class="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">

    <nav>

      <div>
        <h3 class="mb-4 text-xs uppercase leading-[20px] text-gray-400">
          <span
            class="menu-group-title"
            [ngClass]="expanded ? 'lg:block hidden' : 'hidden'"
          >
            Menu
          </span>
          <lucide-icon class="menu-group-icon mx-auto fill-current" [ngClass]="expanded ? 'lg:hidden' : 'lg:block hidden'" [name]="EllipsisIcon"></lucide-icon>
        </h3>

        <ul class="mb-6 flex flex-col gap-4">
          @for (item of filteredMainItems; track item.title) {
            <li>
              <a routerLink="{{ item.route }}" [routerLinkActive]="'menu-item-active'" class="menu-item menu-item-inactive group" (click)="onNavigate()">
                <lucide-icon [name]="item.icon"></lucide-icon>
                <span class="menu-item-text" [ngClass]="expanded ? '' : 'lg:hidden'">
                  {{ item.title }}
                </span>
                @if (item.badgeKey === 'new-quotes') {
                  @let badgeCount = (newQuotesCount$ | async) ?? 0;
                  @if (badgeCount > 0) {
                    <span
                      class="ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-error-500 px-1.5 text-xs font-medium leading-5 text-white"
                      data-testid="sidebar-new-quotes-badge"
                      [ngClass]="expanded ? '' : 'lg:hidden'"
                      [attr.aria-label]="badgeCount + ' new quotes'"
                    >
                      {{ badgeCount }}
                    </span>
                  }
                }
              </a>
            </li>
          }
        </ul>
      </div>

      @if (filteredManageItems && filteredManageItems.length > 0) {
        <div>
          <h3 class="mb-4 text-xs uppercase leading-[20px] text-gray-400">
          <span
            class="menu-group-title"
            [ngClass]="expanded ? 'lg:block hidden' : 'hidden'"
          >
            Manage
          </span>

            <lucide-icon class="menu-group-icon mx-auto fill-current" [ngClass]="expanded ? 'lg:hidden' : 'lg:block hidden'" [name]="EllipsisIcon"></lucide-icon>
          </h3>

          <ul class="mb-6 flex flex-col gap-4">
            @for (item of filteredManageItems; track item.title) {
              <li>
                <a routerLink="{{ item.route }}" [routerLinkActive]="'menu-item-active'" class="menu-item menu-item-inactive group" (click)="onNavigate()">
                  <lucide-icon [name]="item.icon"></lucide-icon>
                  <span class="menu-item-text" [ngClass]="expanded ? '' : 'lg:hidden'">
                  {{ item.title }}
                </span>
                </a>
              </li>
            }
          </ul>
        </div>
      }

    </nav>
  </div>
</aside>
